import React, { useState, useEffect } from 'react';
import { functionTexts } from '../contexts/LangZC';

// 이미지 import
import feature1 from '../assets/zc-safetyzoneEncrypted.png';
import feature2 from '../assets/zc-authentication.png';
import feature3 from '../assets/zc-winword.png';
import feature4 from '../assets/zc-zed.png';
import feature5 from '../assets/zc-xzed.png';
import feature6 from '../assets/zc-dashboard.png';

const functionImages = [feature1, feature2, feature3, feature4, feature5, feature6];

export function getFeatures(lang = 'ko') {
  return functionTexts.functions.map((item, idx) => ({
    title: item.title[lang],
    desc: item.desc[lang],
    img: functionImages[idx]
  }));
}

function ProductZCFunction({ lang = 'ko', isMobile = false }) {
  const [isInternalMobile, setIsInternalMobile] = useState(false);
  
  useEffect(() => {
    const checkMobile = () => {
      setIsInternalMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // isMobile prop이 전달되면 그것을 사용하고, 그렇지 않으면 내부 상태 사용
  const mobile = isMobile || isInternalMobile;
  
  // features를 함수 내부에서만 사용하도록 선언
  const functions = getFeatures(lang);

  return (
    <section
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: '#3a3570', // 바탕색을 #3a3570으로 변경
        borderRadius: 16,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        marginBottom: mobile ? 30 : 40,
        padding: mobile ? '32px 20px' : '48px 40px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        minHeight: mobile ? 'auto' : 320
      }}
    >
      <span
        style={{
          fontSize: mobile ? '1.8rem' : '2.2rem',
          fontWeight: 700,
          color: '#fff',
          margin: mobile ? '20px 0 20px 0' : '32px 0 24px 0',
          alignSelf: 'flex-start',
          textAlign: 'center', // 가운데 정렬 추가
          width: '100%'        // 부모 div 기준으로 가운데 정렬 적용

        }}
      >
        {functionTexts.title[lang]}
      </span>
      <div
        className="zc-feature-grid"
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: mobile ? 'column' : 'row',
          flexWrap: mobile ? 'nowrap' : 'wrap',
          gap: mobile ? 20 : 38,
          alignItems: 'stretch',
          justifyContent: 'center', // 가운데 정렬
        }}
      >
        {functions.map((functions, idx) => (
          <div
            key={idx}
            className="zc-feature-box"
            style={{
              flex: mobile ? 'none' : '1 1 600px',
              width: mobile ? '100%' : 'auto',
              background: '#F5F6FA', // 박스 바탕색 변경
              borderRadius: mobile ? 16 : 19,
              boxShadow: '0 3px 15px rgba(0,0,0,0.10)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: mobile ? 20 : 29,
              minWidth: mobile ? 'auto' : 400,
              maxWidth: mobile ? 'none' : 700,
              minHeight: mobile ? 200 : 260,
              marginBottom: mobile ? 0 : 24,
              boxSizing: 'border-box',
              transition: 'max-width 0.2s, min-width 0.2s',
              position: 'relative',
              overflow: 'hidden',
              color: '#222', // 박스 내 글씨색 변경
            }}
          >
            <div style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-end',
              position: 'relative',
              flex: 1
            }}>
              <img
                src={functions.img}
                alt={functions.title}
                style={{
                  width: '100%',
                  maxWidth: mobile ? 280 : 400,
                  height: 'auto',
                  marginBottom: mobile ? 12 : 19,
                  display: 'block',
                  objectFit: 'contain'
                }}
              />
              {/* 설명 텍스트 애니메이션 */}
              <div
                className="zc-feature-desc-anim"
                style={{
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  bottom: 0,
                  height: '50%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  transform: 'translateY(100%)',
                  opacity: 0,
                  background: 'rgba(20,20,40,0.7)',
                  borderRadius: '0 0 12px 12px',
                  padding: mobile ? '0 12px 12px 12px' : '0 18px 18px 18px',
                  color: '#222', // 기본은 검정색
                  fontSize: mobile ? '1rem' : '1.2rem',
                  fontWeight: 500,
                  textAlign: 'center',
                  zIndex: 3,
                  pointerEvents: 'none',
                  transition: 'transform 0.5s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.5s cubic-bezier(0.23, 1, 0.32, 1)',
                  textShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}
              >
                <div
                  className="zc-feature-desc-title"
                  style={{
                    fontSize: mobile ? '1.2rem' : '1.5rem',
                    fontWeight: 700,
                    color: '#222', // 기본은 검정색, 마우스 오버시 흰색으로 변경됨
                    marginBottom: mobile ? 6 : 8,
                    textShadow: '0 2px 8px rgba(0,0,0,0.08)'
                  }}
                >
                  {functions.title}
                </div>
                {functions.desc}
              </div>
              {/* 제목은 항상 박스 하단에 고정 */}
              <div
                className="zc-feature-title-static"
                style={{
                  width: '100%',
                  background: 'none',
                  borderRadius: 0,
                  padding: '0 0 8px 0',
                  marginBottom: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  zIndex: 2,
                  transition: 'opacity 0.4s'
                }}
              >
                <div style={{
                  fontSize: mobile ? '1.2rem' : '1.44rem',
                  fontWeight: 700,
                  color: '#222', // 제목도 검정색
                  textAlign: 'center',
                  zIndex: 2,
                  textShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}>
                  {functions.title}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* 호버 효과 스타일 */}
      <style>
        {`
        .zc-feature-box:hover .zc-feature-desc-anim {
          opacity: 1 !important;
          transform: translateY(0) !important;
          pointer-events: auto !important;
          color: #fff !important;
        }
        .zc-feature-box:hover .zc-feature-desc-title {
          color: #fff !important; /* 마우스 오버시 제목도 흰색 */
        }
        .zc-feature-desc-anim {
          opacity: 0;
          transform: translateY(100%);
          pointer-events: none;
        }
        .zc-feature-box:hover .zc-feature-title-static {
          opacity: 0 !important;
        }
        .zc-feature-title-static {
          opacity: 1;
          transition: opacity 0.4s;
        }
        `}
      </style>
    </section>
  );
}

export default ProductZCFunction;